import { ISuggestionEntry } from "@faire/retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import { Row } from "@faire/web/slate/Layout";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { type JSX } from "react";

export const PillsWithImageRow: React.FC<{
  sectionHeader: string;
  suggestionArray: ISuggestionEntry[];
  sectionIndex: number;
  trackView: (
    sectionHeader: string,
    suggestionArray: ISuggestionEntry[],
    sectionIndex: number
  ) => void;
  buildRecentSearchesImageItem?: (suggestion: ISuggestionEntry) => JSX.Element;
  buildTrendingSearchImageItem?: (suggestion: ISuggestionEntry) => JSX.Element;
}> = ({
  sectionHeader,
  suggestionArray,
  sectionIndex,
  trackView,
  buildRecentSearchesImageItem,
  buildTrendingSearchImageItem,
}) => {
  const ref = useDoActionWhenVisible(() => {
    trackView(sectionHeader, suggestionArray, sectionIndex);
  });

  return (
    <Row
      className="flex flex-wrap px-2.5 py-0.5"
      align="center"
      tabIndex={-1}
      ref={ref}
    >
      {suggestionArray.map((suggestion: ISuggestionEntry) => {
        if (buildRecentSearchesImageItem) {
          return buildRecentSearchesImageItem(suggestion);
        } else if (buildTrendingSearchImageItem) {
          return buildTrendingSearchImageItem(suggestion);
        }
        return null;
      })}
    </Row>
  );
};
